<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Strony</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-tabs v-model="activeTab">
        <v-tab v-for="slot in slotsTypes" exact :key="slot.name" :to="route(slot)">{{ slot.name }}</v-tab>

        <v-layout text-xs-right>
          <v-flex>
            <check-permission permissions="PAGE.ADD">
              <v-btn large color="error" @click="showAddModal">DODAJ STRONĘ</v-btn>
            </check-permission>
          </v-flex>
        </v-layout>
      </v-tabs>

      <material-table
        entity-type="page"
        :headers="table.headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć stronę?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="addPage"
      @update="updatePage"
    />
  </v-container>
</template>
<script>
import {
  PageSlots,
  PageSlotsTranslation,
  PageType,
  PageTypeTranslation,
  State,
  StateString,
  StateTranslation
} from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import Modal from './add.modal';

// @vuese
// Wyświetlanie listy Stron
// @group Pages
export default {
  data() {
    return {
      table: {
        headers: [
          { value: 'priority', text: 'Priorytet ', sortable: true },
          { value: 'name', text: 'Nazwa', sortable: true },
          { value: 'typeTranslated', text: 'Typ', sortable: true, orderBy: 'type' },
          { value: 'state', text: 'Stan', sortable: true, orderBy: 'state' }
        ]
      },
      actions: [DELETE_ACTION, EDIT_ACTION],
      activeTab: this.$route.path
    };
  },
  mixins: [
    listMixin('pages', {
      listError: 'Wystąpił błąd podczas pobierania listy stron.',
      getError: 'Wystąpił błąd podczas pobierania danych strony.',
      added: 'Dodano stronę.',
      addError: 'Nie udało się dodać strony.',
      updated: 'Zaktualizowano dane strony.',
      updateError: 'Nie udało się zaktualizować danych strony.',
      deleted: 'Usunięto stronę.',
      deleteError: 'Nie udało się usunąć strony.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal,
    Search
  },
  computed: {
    ...mapState({
      list: state => {
        const list = state.pages.list.map(item => {
          item.typeTranslated = PageTypeTranslation[item.type];
          item.stateTranslated =
            State[item.state] === State.NOT_CONFIRMED
              ? StateTranslation[State[StateString.INACTIVE]]
              : StateTranslation[State[item.state]];
          return item;
        });
        return list;
      }
    }),
    slotsTypes() {
      const slotsTypes = Object.keys(PageSlots).map(slot => ({
        route: `/pages/${PageSlots[slot]}`,
        name: PageSlotsTranslation[PageSlots[slot]]
      }));

      slotsTypes.push({
        route: '/pages',
        name: 'Ogólne'
      });
      return slotsTypes;
    }
  },
  methods: {
    // @vuese
    // Dodaje stronę
    addPage(data) {
      this.add({ page: { ...data } });
    },
    // @vuese
    // Aktualizuje stronę
    updatePage(data) {
      const id = data.id;
      data.id = undefined;
      this.update({ page: { ...data }, id });
      this.reloadList(this.$route);
    },
    // @vuese
    // Ustawia filtr paginacji
    filters(pagination, route) {
      const slots = route.params.slot;
      return { ...pagination, slots: slots ? [slots] : undefined, noSlots: !slots || undefined };
    },

    // @vuese
    // Zwraca routing zakładki
    route(slot) {
      return { path: slot.route, query: { ...this.$route.query, page: 1 } };
    }
  }
};
</script>
